import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QueryConfig } from '../../../core/models/QueryConfig';
import { Store } from '../../../store';
import { User, UserRole, RoleEntities } from '../../../core/models/User';
import { DataService } from '../../../core/services/data.service';
import { LegalEntity } from '../../../core/models/LegalEntity';
import * as _ from 'underscore';
import { of } from 'rxjs';

@Component({
    selector: 'app-setting-modal',
    templateUrl: './setting-modal.component.html',
    styleUrls: ['./setting-modal.component.scss'],
    standalone: false
})
export class SettingModalComponent implements OnInit {
    @Input()
    queryConfig: QueryConfig;

    @Input()
    rawUser: User;

    tailProbabilitySelected: boolean = true;
    userDetailsSelected: boolean = false;
    userSelected: boolean = false;
    refreshCache: boolean = false;

    uidList: string[];
    roles: string[] = [
        'USER',
        'ADMIN',
        'SUPERADMIN',
        'AIA GCC',
        'AIA PH',
        'AIA SG',
        'AIA TW',
        'AIA TH',
        'AIA HK',
        'AIA KR',
        'AIA AU',
    ];
    usersRolesList: UserRole[];
    rolesList: RoleEntities[];
    entitiesList: LegalEntity[];

    rawUserSelected: User;
    newUserObject: User;
    selectedRoleString: string = '';
    selectedNewUSerRoleString: string = '';
    tmpUserId: string;
    isNewUserSubmited: boolean = false;
    getUserUid: any
    //selectedEntities: LegalEntity[];
    // TODO REMOVE :
    //usersList: User[];//selectedRole: UserRole;

    constructor(
        public activeModal: NgbActiveModal,
        private store: Store,
        private dataService: DataService
    ) {}

    ngOnInit() {
        this.rawUserSelected = {} as User;
        this.newUserObject = {} as User;
        this.newUserObject.roles = 'ADMIN';

        if (this.isSuperAdmin()) {
            this.getAllUserRoleData();
        }
        this.userSelected = false;
        this.userDetailsSelected = false;
        this.isNewUserSubmited = false;
    }

    onSaveSetting() {
        if (this.userSelected && this.rawUserSelected.uid) {
            const userData: User = this.rawUserSelected;
            const roles: string[] = userData.roles.split(',');
            //console.log("In onSaveSetting() USER DATA: userData.uid = " + userData.uid);
            //console.log("User: " + userData.uid + " isAdmin: " + userData.isAdmin + " isSuperAdmin: "+ userData.isSuperAdmin)
            //roles.forEach((role)=>{console.log("RoleList contains : "+ role)});

            let userList: UserRole[] = [];
            roles.forEach((r) => {
                const tmpRole: UserRole = this.usersRolesList.find((data) => {
                    return data.uid === userData.uid && data.role === r;
                });
                const rowkey =
                    tmpRole && !this.isNewUserSubmited ? tmpRole.rowKey : null;
                // delete special character from inputs
                if (userData.firstName != null || userData.firstName === '') {
                    userData.firstName = userData.firstName.replace(
                        /[^a-zA-Z0-9àâçéèêëîïôûùüÿñæœ\s]/g,
                        ''
                    );
                }
                if (userData.lastName != null || userData.lastName === '') {
                    userData.lastName = userData.lastName.replace(
                        /[^a-zA-Z0-9àâçéèêëîïôûùüÿñæœ\s]/g,
                        ''
                    );
                }
                userList.push({
                    uid: userData.uid,
                    role: r,
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    rowKey: rowkey,
                });
            });
            //userList.forEach((data)=>{console.log("UID: " + data.uid + " Role: " + data.role + " firstname: " + data.firstName + " lastname: "+ data.lastName + "rowKey: "+ data.rowKey)});

            return this.activeModal.close({
                userList,
                userSelected: this.userSelected,
            });
        } else {
            //console.log("In onSaveSetting() QUERY CONFIG");
            return this.activeModal.close({
                queryConfigSetting: this.tailProbabilitySelected
                    ? this.rawUser.queryConfig
                    : this.queryConfig,
                tailProbabilitySelected: this.tailProbabilitySelected,
            });
        }
    }

    getAllUserRoleData() {
        //this.usersRolesList = [];
        this.dataService.getAllUserRoles().subscribe(
            (success) => {
                this.usersRolesList = [];
                success.forEach((element) => {
                    this.usersRolesList.push({
                        uid: element.uid,
                        role: element.role,
                        firstName: element.firstName,
                        lastName: element.lastName,
                        rowKey: element.rowKey,
                    });
                });
                this.uidList = this.usersRolesList
                    ? this.usersRolesList
                          .map((item) => item.uid)
                          .filter(
                              (value, index, self) =>
                                  self.indexOf(value) === index
                          )
                    : [];
                this.setUserDetails(this.rawUser.uid, 'getAllUserRoleData');
                this.tmpUserId = this.rawUser.uid;
            },
            (error) => {
                alert('Error happened while trying to fetch users roles list.');
            }
        );
    }

    updateRole() {
        if (this.selectedRoleString != '') {
            let roles: string[] = this.rawUserSelected.roles.split(',');
            if (
                roles.findIndex((role) => {
                    return role === this.selectedRoleString;
                }) === -1
            ) {
                roles.push(this.selectedRoleString);
                this.rawUserSelected.roles = roles.join();
                //this.updateEntitiesList();
            }
            this.selectedRoleString = '';
        }
    }

    updateNewUserRole() {
        if (this.selectedNewUSerRoleString != '') {
            let roles: string[] = this.newUserObject.roles.split(',');
            if (
                roles.findIndex((role) => {
                    return role === this.selectedNewUSerRoleString;
                }) === -1
            ) {
                roles.push(this.selectedNewUSerRoleString);
                this.newUserObject.roles = roles.join();
                //this.updateEntitiesList();
            }
            this.selectedNewUSerRoleString = '';
        }
    }

    updateEntitiesList() {
        this.entitiesList = [];
        const roles: string[] = this.rawUserSelected.roles.split(',');
        this.rawUserSelected.legalEntities = [];
        //tmpRoles.forEach(element => {
        roles.forEach((element) => {
            let tmp: RoleEntities = this.rolesList.find((val) => {
                return val.roleID === element;
            });
            /*let tmp: RoleEntities[] = this.rolesList.filter(val =>{
        return val.roleID === element
        });
      if (tmp) {
        console.log("Entity available for the Role : " + element);
        tmp.forEach(ele => {
          if (this.entitiesList.findIndex(x => x.dataName==ele.legalEntityName) === -1)
              this.entitiesList.push(ele);
          if (this.rawUserSelected.legalEntities.findIndex(x => x.dataName==ele.legalEntityName) === -1)
              this.rawUserSelected.legalEntities.push(ele);
        })
      }*/
            if (tmp) {
                //console.log("Role detect : " + tmp.roleID);
                tmp.legalEntities.forEach((ele) => {
                    if (
                        this.entitiesList.findIndex(
                            (x) => x.dataName == ele.dataName
                        ) === -1
                    )
                        this.entitiesList.push(ele);
                    if (
                        this.rawUserSelected.legalEntities.findIndex(
                            (x) => x.dataName == ele.dataName
                        ) === -1
                    )
                        this.rawUserSelected.legalEntities.push(ele);
                });
            }
        });
    }

    setUserDetails(uid: any, source: string) {
        let user: any;
        if (source === 'getAllUserRoleData') {
            user = this.rawUser;
        } else if (source === 'getUser') {
            user = { id: uid };
        }
        const userName: UserRole = this.usersRolesList.find(
            (data) => data.uid == user.id
        );
        this.rawUserSelected = {
            uid: user.id,
            firstName: userName.firstName ? userName.firstName : '',
            lastName: userName.lastName ? userName.lastName : '',
            isAdmin:
                this.usersRolesList.findIndex(
                    (data) => data.role == 'ADMIN' && data.uid == user.id
                ) === -1
                    ? false
                    : true,
            isSuperAdmin:
                this.usersRolesList.findIndex(
                    (data) => data.role == 'SUPERADMIN' && data.uid == user.id
                ) === -1
                    ? false
                    : true,
            roles: this.setRole(user.id),
            legalEntities: _.sortBy(user.legalEntities, (x: any) => x.name),
            queryConfig: null,
        };
    }

    // Get user details
    getUser(uid: string) {
        if (uid !== '') {
            this.dataService.getRawUser(uid).subscribe(
                (success) => {
                    //console.log("In getUser : " + success.id);
                    this.setUserDetails(uid, 'getUser');
                    //console.log("rawUserSelected ID: " + this.rawUserSelected.uid);
                    //console.log("rawUserSelected roles: " + this.rawUserSelected.roles);
                    //console.log("rawUserSelected firstName: " + this.rawUserSelected.firstName);
                    //console.log("rawUserSelected lastName: " + this.rawUserSelected.lastName);
                    this.rawUserSelected.roles = this.setRole(uid);
                    //this.updateEntitiesList();
                    this.isNewUserSubmited = false;
                },
                (error) => {
                    alert('Error happened while trying to fetch user profile.');
                }
            );
        }
    }

    setRole(uid: string): string {
        let currentRoles: string[] = [];
        this.usersRolesList.forEach((data) => {
            if (data.uid === uid) {
                currentRoles.push(data.role.toUpperCase());
            }
        });
        return currentRoles.join();
    }

    // Add user
    createUser(newUser: string, clonedUser: string) {
        this.newUserObject.uid = newUser.toLocaleLowerCase();
        // verify UID string format
        if (!/[^a-zA-Z0-9\-_]/g.test(newUser)) {
            if (
                !this.usersRolesList.find((user) => {
                    return user.uid === newUser.toLocaleLowerCase();
                })
            ) {
                if (clonedUser === undefined) {
                    this.rawUserSelected.roles = 'ADMIN';
                    this.rawUserSelected.isSuperAdmin = false;
                    this.rawUserSelected.isAdmin = false;
                    // this.newUserObject.roles = "ADMIN";
                    //this.updateEntitiesList();
                } else {
                    //clone user
                    this.getUser(clonedUser);
                    //clone only roles and keep uid, firstName and lastName the same as newUserObject
                    this.rawUserSelected.uid = newUser.toLocaleLowerCase();
                    this.rawUserSelected.firstName =
                        this.newUserObject.firstName;
                    this.rawUserSelected.lastName = this.newUserObject.lastName;
                }
                this.rawUserSelected.uid = newUser.toLocaleLowerCase();
                this.rawUserSelected.firstName = this.newUserObject.firstName;
                this.rawUserSelected.lastName = this.newUserObject.lastName;
                this.rawUserSelected.queryConfig = null;
                this.rawUserSelected.roles = this.newUserObject.roles;
                /*this.userDetailsSelected = */
                this.isNewUserSubmited = true;
            } else {
                alert(
                    'UID already exists. Go to User Details screen to edit this user informations'
                );
            }
        } else {
            alert('Enter a valid UID');
        }
    }

    // Delete user
    deleteUser(uid: string, role: string) {
        if (
            confirm(
                'Are you sure to delete ' + uid + ' and his role ' + role + '?'
            )
        ) {
            const user: UserRole = this.usersRolesList.find((item) => {
                return item.uid === uid && item.role === role;
            });
            if (user) {
              this.usersRolesList = this.usersRolesList.filter(
                (item) => !(item.uid === uid && item.role === role)
            );
            this.getAllUserRoleData();
                //console.log("Delete user submitted : " + user.uid + " with Role " + user.role + " with rowkey " + user.rowKey);
                this.dataService.deleteUser(user).subscribe(
                    (success) => {
                        if (success){
                            alert(
                                'User role ' +
                                    user.role +
                                    ' for user ' +
                                    user.uid +
                                    ' successfully deleted'
                            );
                            this.getAllUserRoleData();
                          }else{
                            alert(
                                'Error happened while trying to delete user role for ' +
                                    uid
                            );
                            }
                          },
                    (error) => {
                        alert(
                            'Error happened while trying to delete user role.'
                        );
                        this.getAllUserRoleData();
                    }
                );
            } else {
                alert(
                    'Error happened while trying to delete user role for ' + uid
                );
            }
        }
    }

    deleteRoleItem(role) {
        let rolesArray: string[] = this.newUserObject.roles.split(',');
        if (rolesArray.length > 1) {
            rolesArray.splice(rolesArray.indexOf(role), 1);
            this.newUserObject.roles = rolesArray.join();
        }
    }

    /*getEntitiesByRoles() {
    this.rolesList = [];
    this.dataService.getEntitiesByRoles().subscribe(success => {
        console.log('Roles and Entities successfully fetched');
        success.forEach(element => {
          this.rolesList.push({roleID: element.roleID ,roleName: element.roleName, legalEntities: element.legalEntities});
          //this.rolesList.push({roleID: element.roleId ,entityID: element.entityId, legalEntityName: element.legalEntityName});
        });
        //this.rolesList = success;
    }, error => {
        alert('Error happened while trying to fetch entities and roles list.');
    });
  }*/

    /*addEntity() {
    console.log("Add Entity");
    if (this.selectedEntities !== null){
        console.log("First value : " + this.selectedEntities[0].dataName);
        this.selectedEntities.forEach((val)=>{
            console.log("Push Entity :" + val.dataName);
            this.rawUserSelected.legalEntities.find(value =>{ return val.name === value.name}) ? console.log("This entity already exists") : this.rawUserSelected.legalEntities.push(val);
        });
        this.selectedEntities = null;
    }
  }*/

    /*removeEntity() {
    console.log("Remove Entity");
    if (this.selectedEntities.length !== 0){
        console.log("Selected Entities :" + this.selectedEntities);
        this.selectedEntities.forEach((val)=>{
            console.log("Delete Entity :" + val.dataName);
            this.rawUserSelected.legalEntities = this.rawUserSelected.legalEntities.filter(function(ele){return ele.name != val.name;});
        });
        //this.currentEntitiesList = this.filterEntities(this.currentEntitiesList, this.selectedEntities);
        this.selectedEntities = null;
    }
  }*/

    splitItem(item: string): string[] {
        return item.split(',');
    }

    isSuperAdmin(): Boolean {
        return this.store.value.user.isSuperAdmin ? true : false;
    }

    getSelectedClonedUser(uid) {
        if (uid !== 'undefined' && uid !== null) {
            this.getClonedUserRoles(uid);
        } else {
            this.newUserObject.roles = 'ADMIN';
            this.rawUserSelected.roles = this.newUserObject.roles;
        }
    }

    getClonedUserRoles(clonedUserID: string) {
        this.dataService.getRawUser(clonedUserID).subscribe(
            (success) => {
                this.newUserObject.roles = this.setRole(success.id);
            },
            (error) => {
                alert('Error happened while trying to fetch user profile.');
            }
        );
    }

    showConfirmationPopup() {
        const modal = document.getElementById('confirmationPopup');
        if (modal) {
          modal.style.display = 'block';
        }
      }
    
      confirmCleanCache() {
        console.log('Cache cleaned');
        this.dataService.getRefreshCache().subscribe(
            (data) => {
              console.log('Data received:', data);
            },
        );
        this.closePopup();
      }
    
      cancelCleanCache() {
        this.closePopup();
      }
    
      closePopup() {
        const modal = document.getElementById('confirmationPopup');
        if (modal) {
          modal.style.display = 'none';
        }
      }
}
